import queryString from 'query-string';
import { takeLatest, call, all, put, select } from 'redux-saga/effects';

import taskService, {
  transformApiToFilterParams,
  transformFiltersParamsToApi,
} from 'services/taskService';
import teamService from 'services/teamService';

import { getGroupId } from 'store/session/selectors';

import history from 'utils/browserHistory';

import { buildFilters, fetchTasks, filters, types } from './actions';
import {
  getAssignedToIn,
  getCurrentPage,
  getQuoteNumber,
  getStatusIn,
} from './reducer';

export default function* root() {
  yield takeLatest(types.FILTERS_SET, watchBuildFilters);
  yield takeLatest(types.FETCH_TASKS_REQUEST, watchFetchTasks);
  yield takeLatest(types.FILTERS_APPLY, watchReloadPage);
  yield takeLatest(types.PAGINATION_SET, watchReloadPage);
}

export function* initTasksListPage({ location }) {
  const queryParams = queryString.parse(location.search);
  const page = queryParams.page || 1;
  const { assignedToIn, quoteNumber, statusIn } =
    transformApiToFilterParams(queryParams);
  yield put(filters.set({ assignedToIn, quoteNumber, page, statusIn }));
  yield put(fetchTasks.request());
}

function* watchBuildFilters() {
  // gather all neccessary data for displaying active filters
  try {
    const [assignedToIn, quoteNumber, statusIn] = yield all([
      select(getAssignedToIn),
      select(getQuoteNumber),
      select(getStatusIn),
    ]);
    if (assignedToIn.length > 0) {
      // need to make sure all team mates are available
      const groupId = yield select(getGroupId);
      const teamMembers = yield call(teamService.getTeamMembers, groupId);
      const invalidAssingedTo = [];
      assignedToIn.forEach((userId) => {
        if (!teamMembers.some((teamMember) => teamMember.userId == userId)) {
          invalidAssingedTo.push(userId);
        }
      });
      if (invalidAssingedTo.length > 0) {
        // remove invalid values
        yield put(
          filters.apply({
            assignedToIn: assignedToIn.filter(
              (assignedTo) => !invalidAssingedTo.includes(assignedTo),
            ),
            quoteNumber,
            statusIn,
          }),
        );
      } else {
        yield put(
          buildFilters.success({
            teamMembers,
          }),
        );
      }
    }
  } catch (error) {
    yield put(buildFilters.error(error));
  }
}

function* watchFetchTasks() {
  try {
    const [assignedToIn, page, quoteNumber, statusIn] = yield all([
      select(getAssignedToIn),
      select(getCurrentPage),
      select(getQuoteNumber),
      select(getStatusIn),
    ]);

    const queryParams = {
      ...transformFiltersParamsToApi({
        assignedToIn,
        page,
        quoteNumber,
        statusIn,
      }),
    };

    const { count, results } = yield call(taskService.list, queryParams);
    yield put(fetchTasks.success({ count, tasks: results }));
  } catch (error) {
    yield put(fetchTasks.error(error));
  }
}

function* watchReloadPage() {
  try {
    const [assignedToIn, page, quoteNumber, statusIn] = yield all([
      select(getAssignedToIn),
      select(getCurrentPage),
      select(getQuoteNumber),
      select(getStatusIn),
    ]);
    const queryParams = queryString.stringify({
      ...transformFiltersParamsToApi({
        assignedToIn,
        page,
        quoteNumber,
        statusIn,
      }),
    });

    history.push(`/tasks${queryParams ? `?${queryParams}` : ''}`);
  } catch (error) {
    console.error('Failed to reload tasks page', error);
  }
}
